import React from 'react'

function initSpinner(contrastModifier) {
  return <div className={contrastModifier ? `spinner spinner--${contrastModifier}` : 'spinner'} />
}

export function Spinner({ isInitialized, contrastModifier }) {
  return isInitialized ? <noscript /> : initSpinner(contrastModifier)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/spinner/spinner.js